import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
export const BaseInput = ({
  register,
  error,
  label,
  validation,
  name,
  placeholder,
  defaultValue,
  style,
  required,
  type,
  disabled
}) => {
  const { t } = useTranslation();

  return (
    <div>
      {label && (
        <label
          htmlFor={name}
          className="text-slate-600 text-sm capitalize  leading-tight tracking-normal">
          {label}
        </label>
      )}
      {required && (
        <label
          htmlFor={name}
          className="text-red-600 mx-2 text-xs capitalize  leading-tight tracking-normal">
          الحقل مطلوب *
        </label>
      )}
      <input
        id={name}
        className={`input ${error ? 'border-red-400 bg-red-50' : style}`}
        type={type}
        placeholder={placeholder}
        {...register(name, validation)}
        defaultValue={defaultValue}
        disabled={disabled}
      />
      <div className="text-red-500 text-xs !h-4 ">{t(error?.message)}</div>
    </div>
  );
};

BaseInput.propTypes = {
  error: PropTypes.object,
  register: PropTypes.func,
  label: PropTypes.string,
  validation: PropTypes.object,
  name: PropTypes.string,
  defaultValue: PropTypes.any,
  placeholder: PropTypes.string,
  style: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool
};
BaseInput.defaultProps = {
  style: 'primary',
  type: 'text',
  required: false,
  disabled: false
};
